import { ClientModelAggregationType } from "@services/api/types";
import { DateTime } from "luxon";
import { useMemo } from "react";

export const FORECAST_PERIOD = 8;

const formatYearISO2 = (year: number): string => {
  return (year % 100).toString();
};

const toWeekFormat = (index: number) => {
  const weekDate = DateTime.now().plus({ weeks: index + 1 });
  const weekNumber = weekDate.weekNumber;
  return `${formatYearISO2(weekDate.weekYear)}W${weekNumber.toLocaleString(
    "es-ES",
    {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      minimumIntegerDigits: 2
    }
  )}`;
};

const toMonthFormat = (index: number) => {
  const monthDate = DateTime.now().plus({ months: index + 1 });
  const monthNumber = monthDate.month;
  return `${formatYearISO2(monthDate.year)}M${monthNumber.toLocaleString(
    "es-ES",
    {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      minimumIntegerDigits: 2
    }
  )}`;
};

// Returns the number of ISO weeks in the given week-year (52 or 53).
const weeksInYear = (weekYear: number): number =>
  DateTime.local(weekYear, 12, 28).weekNumber;

export const useTimePeriods = (
  aggregation_type: ClientModelAggregationType
): string[] => {
  const periods = useMemo(() => {
    if (aggregation_type === "weekly") {
      // Generate every week from next week up to (and including) the same
      // ISO week number in the following year, which equals the total number
      // of ISO weeks in the current year (52 or 53).
      const count = weeksInYear(DateTime.now().weekYear);
      return Array.from({ length: count }).map((_, index) =>
        toWeekFormat(index)
      );
    }
    // For monthly / yearly aggregation: always cover the next 12 months.
    return Array.from({ length: 12 }).map((_, index) => toMonthFormat(index));
  }, [aggregation_type]);

  return periods;
};
